"use strict";
//@ts-nocheck
/**
 * Handle images
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
Object.defineProperty(exports, "__esModule", { value: true });
const _main_1 = require("./_main");
_main_1.txGs1Base.images = {
    lazyLoadBackground: function ($imageElement) {
        $imageElement.unveilBackground(15, function () {
            $(this).load(function () {
            });
        });
    },
    attachLazyLoading: function () {
        'use strict';
        _main_1.txGs1Base.images.lazyLoadBackground($('[data-background-src]'));
        // workaround lazyloading failures & url hash bug in firefox
        if (window.location.hash.length < 1) {
            window.scrollTo(0, 1);
            window.scrollTo(0, 0);
        }
    },
    initialize: function () {
        'use strict';
        _main_1.txGs1Base.images.attachLazyLoading();
        _main_1.txGs1Base.images.lightbox.setAnchors();
        _main_1.txGs1Base.images.lightbox.attach();
        _main_1.txGs1Base.respond.addFunc({
            breakpoint: ['handheld'],
            enter: function () {
                _main_1.txGs1Base.images.lightbox.detach();
            },
            exit: function () {
                _main_1.txGs1Base.images.lightbox.attach();
            }
        });
    }
};
exports.default = {};
